Librarian.ConfirmWindow = new Class({
    Extends: Librarian.Window,

    options: {
        id: "ConfirmWindow",
        title: "",
        minimizable: false,
        height: 90,
        width: 280,
        firstButtonText: null,
        firstButtonClass: "pure-button-primary",
        secondButtonText: null,
        secondButtonClass: null,
        useSecondButton: true,
        thirdButtonText: null,
        thirdButtonClass: null,
        useThirdButton: false,
        // Whether or not to run onComplete when the third button is clicked
        doCompleteOnThirdButton: false,
        fourthButtonText: null,
        fourthButtonClass: null,
        useFourthButton: false,
        fifthButtonText: null,
        fifthButtonClass: null,
        useFifthButton: false,
        question: null,
        resize: true,
        contentURL: null,
        defaultButton: 0
    },

    onFirstButtonClicked: null,
    onSecondButtonClicked: null,
    onThirdButtonClicked: null,
    onFourthButtonClicked: null,
    onFifthButtonClicked: null,
    onComplete: null,
    onAfterClose: null,

    // Number of button that was clicked (1-based)
    buttonClicked: null,

    initialize: function(options) {
        this.setOptions(options);

        // Load default values for the button names here so that
        // they can each be translated
        if (this.options.firstButtonText == null)
            this.options.firstButtonText = Librarian.Lang.getString("yes");
        if (this.options.secondButtonText == null)
            this.options.secondButtonText = Librarian.Lang.getString("no");
        if (this.options.thirdButtonText == null)
            this.options.thirdButtonText = Librarian.Lang.getString("cancel");

        if (this.options.question && this.options.resize) {
            var width = (this.options.question.length * 8);
            if (this.options.width < width)
                this.options.width = width;
        }

        if (this.options.contentURL == null)
            this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/confirm.html";

        this.parent(this.options);
    },

    onClose: function() {
        this.parent();

        if (!this.buttonClicked) {
            if (this.options.defaultButton == 1)
                this.onButtonOneClicked(true);
            else if ((this.options.defaultButton == 2) && this.options.useSecondButton)
                this.onButtonTwoClicked(true);
            else if ((this.options.defaultButton == 3) && this.options.useThirdButton)
                this.onButtonThreeClicked(true);
            else if ((this.options.defaultButton == 4) && this.options.useFourthButton)
                this.onButtonFourClicked(true);
            else if ((this.options.defaultButton == 5) && this.options.useFifthButton)
                this.onButtonFiveClicked(true);
        }

        if (typeof this.onAfterClose == "function")
            this.onAfterClose(this.buttonClicked);
    },

    onWindowLoaded: function() {
        this.parent();

        var itemEl = $("question");
        if (itemEl && this.options.question) {
            if (this.options.questionIsHtml) {
                itemEl.set("html", this.options.question);
            }
            else {
                itemEl.set("html", Librarian.Utils.textToHtml(this.options.question));
            }
            itemEl.id = this.options.id + '_' + itemEl.id;
        }

        itemEl = $("firstButton");
        if (itemEl) {
            // Add the onclick method
            itemEl.addOnClick(this.onButtonOneClicked, this);
            // And update the ID
            itemEl.id = this.options.id + '_' + itemEl.id;
            // And set the button text
            itemEl.value = this.options.firstButtonText;

            if (typeof this.options.firstButtonClass == "string")
                itemEl.addClass(this.options.firstButtonClass);
        }

        itemEl = $("secondButton");
        if (itemEl) {
            // If the second button is disabled, destroy it
            if (!this.options.useSecondButton)
                itemEl.destroy();
            else {
                // Add the onclick method
                itemEl.addOnClick(this.onButtonTwoClicked, this);
                // And update the ID
                itemEl.id = this.options.id + '_' + itemEl.id;
                // And set the button text
                itemEl.value = this.options.secondButtonText;

                if (typeof this.options.secondButtonClass == "string")
                    itemEl.addClass(this.options.secondButtonClass);
            }
        }

        itemEl = $("thirdButton");
        if (itemEl) {
            // If the third button is disabled, destroy it
            if (!this.options.useThirdButton)
                itemEl.destroy();
            else {
                // Add the onclick method
                itemEl.addOnClick(this.onButtonThreeClicked, this);
                // And update the ID
                itemEl.id = this.options.id + '_' + itemEl.id;
                // And set the button text
                itemEl.value = this.options.thirdButtonText;

                if (typeof this.options.thirdButtonClass == "string")
                    itemEl.addClass(this.options.thirdButtonClass);
            }
        }

        itemEl = $("fourthButton");
        if (itemEl) {
            // If the fourth button is disabled or no text was set, destroy it
            if (!this.options.useFourthButton || ((this.options.fourthButtonText || '').trim().length == 0))
                itemEl.destroy();
            else {
                // Add the onclick method
                itemEl.addOnClick(this.onButtonFourClicked, this);
                // And update the ID
                itemEl.id = this.options.id + '_' + itemEl.id;
                // And set the button text
                itemEl.value = this.options.fourthButtonText;
                // This button is hidden by default
                itemEl.show("inline-block");

                if (typeof this.options.fourthButtonClass == "string")
                    itemEl.addClass(this.options.fourthButtonClass);
            }
        }

        itemEl = $("fifthButton");
        if (itemEl) {
            // If the fifth button is disabled or no text was set, destroy it
            if (!this.options.useFifthButton || ((this.options.fifthButtonText || '').trim().length == 0))
                itemEl.destroy();
            else {
                // Add the onclick method
                itemEl.addOnClick(this.onButtonFiveClicked, this);
                // And update the ID
                itemEl.id = this.options.id + '_' + itemEl.id;
                // And set the button text
                itemEl.value = this.options.fifthButtonText;
                // This button is hidden by default
                itemEl.show("inline-block");

                if (typeof this.options.fifthButtonClass == "string")
                    itemEl.addClass(this.options.fifthButtonClass);
            }
        }

        this.fireEvent("windowLoaded");
    },

    onButtonOneClicked: function(isClosing) {
        var windowContentsEl = this.getElement("content");
        if ((typeof this.onFirstButtonClicked == "function") && (this.onFirstButtonClicked(windowContentsEl) === false))
            return;
        if (typeof this.onComplete == "function")
            this.onComplete(windowContentsEl);

        this.buttonClicked = 1;

        if (isClosing !== true)
            this.close();
    },

    onButtonTwoClicked: function(isClosing) {
        var windowContentsEl = this.getElement("content");
        if ((typeof this.onSecondButtonClicked == "function") && (this.onSecondButtonClicked(windowContentsEl) === false))
            return;
        if (typeof this.onComplete == "function")
            this.onComplete(windowContentsEl);

        this.buttonClicked = 2;

        if (isClosing !== true)
            this.close();
    },

    onButtonThreeClicked: function(isClosing) {
        var windowContentsEl = this.getElement("content");
        if ((typeof this.onThirdButtonClicked == "function") && (this.onThirdButtonClicked(windowContentsEl) === false))
            return;
        if (this.options.doCompleteOnThirdButton && (typeof this.onComplete == "function"))
            this.onComplete(windowContentsEl);

        this.buttonClicked = 3;

        if (isClosing !== true)
            this.close();
    },

    onButtonFourClicked: function(isClosing) {
        var windowContentsEl = this.getElement("content");
        if ((typeof this.onFourthButtonClicked == "function") && (this.onFourthButtonClicked(windowContentsEl) === false))
            return;

        this.buttonClicked = 4;

        if (isClosing !== true)
            this.close();
    },

    onButtonFiveClicked: function(isClosing) {
        var windowContentsEl = this.getElement("content");
        if ((typeof this.onFifthButtonClicked == "function") && (this.onFifthButtonClicked(windowContentsEl) === false))
            return;

        this.buttonClicked = 5;

        if (isClosing !== true)
            this.close();
    }
});